import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import GetCompany from './views/Get.vue'

export const CompanyRoutes = [
  {
    path: '/companies',
    name: 'ListCompanies',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'company:list'
    }
  },
  {
    path: '/company',
    name: 'CreateCompany',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'company:create'
    }
  },
  {
    path: '/company/:id',
    name: 'UpdateCompany',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'company:update'
    }
  },
  {
    path: '/company/view/:id',
    name: 'GetCompany',
    component: GetCompany,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'company:get'
    }
  }
]
